import { Loader } from '../Widgets';
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { AppSettings } from 'service';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/store';
import attendance_image from '../../assets/images/attendance.png'
import payslip_image from '../../assets/images/payslip.png'
import profile_image from '../../assets/images/profile.png'
import leave_image from '../../assets/images/leave.png'
import regularization_image from '../../assets/images/regularization.png'
import daily_attendance_image from '../../assets/images/daily_attendance.png'
import notification_image from '../../assets/images/notifications.png'
import todo_image from '../../assets/images/todo.png'
import SettingsService from 'service/SettingsService';
import { ActionCreators } from 'store/actionCreators';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faCalendarCheck, faCheckSquare, faEdit, faFileInvoiceDollar, faIdBadge, faPlane, faUser, faUsers } from '@fortawesome/free-solid-svg-icons';

export const Dashboard = () => {
    const userData = useSelector((state: RootState) => state.appdata);
    const [user, setUser] = useState<any>();
    const [company, setCompany] = useState<any>();
    const [settings, setSettings] = useState<AppSettings>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [screenMode, setScreenMode] = useState<string>("main-screen");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (userData.profile) {
            setUser(userData.profile.profile.user);
            setCompany(userData.company);
            setIsLoading(false);

            // Get the server app settings
            SettingsService.get()
                .then((data) => {
                    setSettings(data);
                });
        }
    }, [userData]);

    const changeCompany = () => {
        dispatch(ActionCreators.changeCompany());
    }

    return (
        <>
            <div className="page-dashboard">
                <div className="container">
                    <div className='row'>
                        <div className='page-header card' style={{ paddingBottom: "20px" }}>
                            <b>{company?.name}</b>
                            {userData.profile.profile.companies.length > 1 &&
                                <div className="btn btn-sm btn-success mt-2 float-end" onClick={changeCompany}>
                                    Change Company
                                </div>
                            }
                        </div>
                    </div>
                    {isLoading &&
                        <Loader />
                    }
                    {!isLoading &&
                        <>
                            <div className='row'>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/employees">
                                        <div className="card bg-success">
                                            <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                                <FontAwesomeIcon icon={faUsers} style={{ fontSize: '4rem' }} className="text-white" />
                                            </div>
                                            <div className="card-body">
                                                <h5 className="card-title text-white">Employees</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/notifications">
                                        <div className="card bg-success">
                                             <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                                <FontAwesomeIcon icon={faBell} style={{ fontSize: '4rem' }} className="text-white" />
                                            </div>
                                            <div className="card-body">
                                                <h5 className="card-title text-white">Notifications</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/todo">
                                        <div className="card bg-success">
                                            <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                                <FontAwesomeIcon icon={faCheckSquare} style={{ fontSize: '4rem' }} className="text-white" />
                                            </div>
                                            <div className="card-body">
                                                <h5 className="card-title text-white">To Do</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/attendance">
                                        <div className="card bg-success">
                                            <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                                <FontAwesomeIcon icon={faCalendarCheck} style={{ fontSize: '4rem' }} className="text-white" />
                                            </div>
                                            <div className="card-body">
                                                <h5 className="card-title text-white">Daily Attendance</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/attendance/employee">
                                        <div className="card bg-success">
                                            <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                                <FontAwesomeIcon icon={faIdBadge} style={{ fontSize: '4rem' }} className="text-white" />
                                            </div>
                                            <div className="card-body">
                                                <h5 className="card-title text-white">Employee Attendance</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/regularization">
                                        <div className="card bg-success">
                                            <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                                <FontAwesomeIcon icon={faEdit} style={{ fontSize: '4rem' }} className="text-white" />
                                            </div>
                                            <div className="card-body">
                                                <h5 className="card-title text-white">Attendance Regularizations</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/leave">
                                        <div className="card bg-success">
                                            <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                                <FontAwesomeIcon icon={faPlane} style={{ fontSize: '4rem' }} className="text-white" />
                                            </div>
                                            <div className="card-body">
                                                <h5 className="card-title text-white">Leaves</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/payslip">
                                        <div className="card bg-success">
                                            <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                                <FontAwesomeIcon icon={faFileInvoiceDollar} style={{ fontSize: '4rem' }} className="text-white" />
                                            </div>
                                            <div className="card-body">
                                                <h5 className="card-title text-white">Payslips</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    );
};